import { OnInit, Component } from "@angular/core";
import { DatePipe } from "@angular/common";

import { HttpErrorResponse } from "@angular/common/http";
import { NzMessageService, NzNotificationService } from "ng-zorro-antd";

import {
  GlobalComponent,
  Tempo,
  Result,
  Aziende,
  Dipendente,
} from "../../environments/global";

@Component({
  selector: "app-rfid",
  templateUrl: "rfid.component.html",
  styleUrls: ["rfid.component.scss"],
  providers: [DatePipe],
})
export class RfidComponent implements OnInit {
  // TABLE VARS
  dataSet: Array<any> = [];
  public displayData = [...this.dataSet];
  editCache = {};
  sortName = null;
  sortValue = null;
  // COMPONENT VARS
  newTempo: Tempo = {
    id: new Date(),
    date: new Date(),
    userId: "",
    orderId: "",
    h: 0,
  } as Tempo;
  public newCodeError: string = "validating";
  isLoading: boolean = true;
  isSpinning: boolean = false;
  companyData: Array<string> = Aziende;
  selectedCompany: string;
  selectedMonth: Date;
  orderData: Array<any> = [];
  usersData: Array<Dipendente> = [];
  selectedUser: Dipendente;

  constructor(
    public g: GlobalComponent,
    private notification: NzNotificationService,
    public datepipe: DatePipe,
    private message: NzMessageService
  ) {
    this.setup();
  }
  // ################################################
  // CLASS: ON INIT
  ngOnInit() {
    this.setup();
    this.loadData();
  }
  setup() {
    // SETUP INTERFACE
    this.g.menuState = 4;
    this.g.homeTitle = "Tabella Ingressi";
  }
  loadData() {
    this.isSpinning = true;

    const query: string =
      "Select " +
      "chk_rfid.code, " +
      "chk_users.name, " +
      "chk_users.surname, " +
      "chk_users.company, " +
      "chk_rfid.time_enter, " +
      "chk_rfid.time_exit, " +
      "chk_rfid.marked " +
      "FROM " +
      "chk_rfid Left Join " +
      "chk_users On chk_users.code = chk_rfid.code " +
      "ORDER BY chk_rfid.time_enter DESC";

    this.g.mysql(query).subscribe(
      (res: Result) => {
        this.dataSet = res.data;

        const query: string = "SELECT * from chk_users";
        this.g.mysql(query).subscribe((resUser: Result) => {
          this.usersData = resUser.data;
          this.isLoading = false;
          this.isSpinning = false;
          this.updateEditCache();
        });
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notification.error(
          "Si è vericato un errore non previsto",
          error.statusText,
          { nzDuration: this.g.normalTime }
        );
      }
    );
  }

  loadFilter(): void {
    if (!this.selectedUser || !this.selectedMonth) {
      this.displayData =  [...this.dataSet];
      return;
    }

    // Estrai mese e anno selezionati
    const selectedMonth = this.selectedMonth.getMonth(); // 0-11
    const selectedYear = this.selectedMonth.getFullYear();

    this.displayData = [ ...this.dataSet.filter((item) => {
      const sameName = item.name === this.selectedUser.name;
      const sameSurname = item.surname === this.selectedUser.surname;

      const itemDate = new Date(item.time_enter);
      const sameMonth = itemDate.getMonth() === selectedMonth;
      const sameYear = itemDate.getFullYear() === selectedYear;

      return sameName && sameSurname && sameMonth && sameYear;
    })];
  }

  cancelFilter(): void {
    this.selectedUser = null;
    this.selectedMonth = null;
    this.displayData = [...this.dataSet];
  }

  sort(sort: { key: string; value: string }): void {
    this.sortName = sort.key;
    this.sortValue = sort.value;
    if (this.sortName) {
      this.displayData = [
        ...this.dataSet.sort((a, b) =>
          this.sortValue === "ascend"
            ? a[this.sortName] > b[this.sortName]
              ? 1
              : -1
            : b[this.sortName] > a[this.sortName]
            ? 1
            : -1
        ),
      ];
    } else {
      this.displayData = [...this.dataSet];
    }
  }

  deleteRow(code: string, enter: number): void {
    const index = this.dataSet.findIndex((item) => item.code === code);
    const query: string =
      "DELETE FROM chk_rfid WHERE " +
      "`code`= " +
      code +
      " AND " +
      "`time_enter`= " +
      enter.toString();
    this.isLoading = true;
    this.g.mysql(query).subscribe(
      (res: Result) => {
        this.isLoading = false;
        if (res.error === false) {
          this.dataSet.splice(index, 1);
          this.message.success("Cancellazione completata con successo!");
          this.updateEditCache();
        } else {
          this.notification.error(
            "Si è verificato un problema, si prega di riprovare tra qualche minuto.",
            res.message,
            { nzDuration: this.g.normalTime }
          );
          console.log(res);
        }
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notification.error(
          "Si è vericato un errore non previsto.",
          error.statusText,
          { nzDuration: 0 }
        );
      }
    );
  }

  updateEditCache(): void {
    if (this.dataSet != null) {
      this.dataSet.forEach((item) => {
        if (!this.editCache[item.id]) {
          this.editCache[item.id] = {
            edit: false,
            data: item,
          };
        }
      });
    }
    this.displayData = [...this.dataSet];
  }
}
